import React from 'react';

export default function VirtualTour() {
    return (
        <div className="virtual-tour-container">
            <div className="tour-card">
                
                <iframe
                    src="https://www.google.com/maps/embed?pb=!4v1771653042268!6m8!1m7!1sCAoSHENJQUJJaER1c20wVWZSTlFSUDVGT2ZZWjFaMXI.!2m2!1d15.53340975820258!2d73.76304551516391!3f40!4f0!5f0.7820865974627469"
                    width="600"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
        </div>
    );
}